import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class DashboardDynamicViewsNewRoute extends Route {
  @service store;
  @service metrics;

  activate() {
    window.scrollTo(0, 0);
  }

  model() {
    return this.store.createRecord('dynamic-view');
  }

  afterModel() {
    this.controllerFor('dashboard').unsetSelectedUrl();
  }

  setupController(controller, dynamicView) {
    super.setupController(controller, dynamicView);
    controller.enteredRoute(dynamicView);
  }

  @action
  didTransition() {
    this.metrics.trackEvent({ event: 'Create View' });
    return true;
  }
}
